/** What a scanned QR points at: the short type code and the record id. */
export interface ScanTarget {
  type: string;
  id: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const PATH = /^\/q\/([a-z][a-z0-9]{0,15})\/([^/?#]+)\/?$/i;

/**
 * Reads the text a QR carries. Accepts a full address ({@code https://site/q/fa/<uuid>}) or just the path
 * ({@code /q/fa/<uuid>}); anything else (another site's QR, free text, a bad id) is null. The site is NOT checked
 * here: the server only ever answers for records the signed-in user may open.
 */
export function parseScanUrl(text: string | null | undefined): ScanTarget | null {
  if (!text) return null;
  const raw = text.trim();
  if (!raw) return null;
  let path = raw;
  if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) {
    try {
      const u = new URL(raw);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
      path = u.pathname;
    } catch {
      return null;
    }
  }
  const m = PATH.exec(path);
  if (!m) return null;
  const id = m[2];
  if (!UUID.test(id)) return null;
  return { type: m[1].toLowerCase(), id: id.toLowerCase() };
}
